$(document).ready(function(){
    'use strict'

    //Реализация табов
    $('.tabs').each(function() {
        let ths = $(this);
        ths.find('.tabs__name').on('click',function() {
            ths.find('.tabs__name').removeClass('active').eq($(this).index()).addClass('active');
            ths.find('.tabs__item').hide().eq($(this).index()).fadeIn();
        }).eq(0).addClass('active');

        //Открытие по хэшу
        if (location.href.indexOf('#') >= 0) {
            const hashName = getHashValue(location.href);
            const elemItem = $(`.tabs__item--${hashName}`);
            const elemName = $(`.tabs__name--${hashName}`);

            ths.find('.tabs__name').removeClass('active');
            ths.find('.tabs__item').hide();
            elemItem.show();
            elemName.addClass('active');
        } else {
            ths.find('.tabs__item').not(':first').hide();
        }
    });
});
